<template>
    <model-modal
        :model-class="modelClass"
        slotContainerClasses="w-full h-full relative"
        @opening="onOpening"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <template v-if="slotProps.model">
                <div class="h-full flex flex-col">
                    <div class="flex-1">
                        <h2 class="mb-8 text-xl font-medium text-gray-800">{{ slotProps.model.name }}</h2>
                        <div class="flex mb-8">
                            <a href="#" @click.prevent="tab = 'preview'" class="inline-block pb-1 mr-6 font-medium" :class="tab == 'preview' ? 'text-primary border-b-2 border-primary' : 'gray-800'">
                                {{ $t('worksite.files.file_modal.tabs.preview') }}
                            </a>
                            <a href="#" @click.prevent="tab = 'details'" class="inline-block pb-1 font-medium" :class="tab == 'details' ? 'text-primary border-b-2 border-primary' : 'text-gray-800'">
                                {{ $t('worksite.files.file_modal.tabs.details') }}
                            </a>
                        </div>
                        <div class="flex flex-col flex-1 pb-16" v-if="tab == 'preview'">
                            <div class="mb-6" :class="{'flex-1': slotProps.model.isPDF()}" v-if="slotProps.model.isImage() || slotProps.model.isPDF()">
                                <div class="flex items-center justify-center p-4 bg-gray-700 rounded" v-if="slotProps.model.isImage()">
                                    <img :src="slotProps.model.url_preview" class="block w-auto h-auto" style="max-height: 200px; max-width: 500px" />
                                </div>
                                <div class="block h-full p-4 bg-gray-700 rounded" v-if="slotProps.model.isPDF()">
                                    <iframe :src="`${slotProps.model.url}#navpanes=0`" height="100%" width="100%" class="min-h-[500px]" />
                                </div>
                            </div>
                            <div>
                                <v-spa-loading-button @clicked="downloadFile(slotProps.model)">
                                    {{ $t('worksite.files.file_modal.download') }}
                                </v-spa-loading-button>
                            </div>
                        </div>
                        <div class="flex-1" v-if="tab == 'details'">
                            <div class="mb-4">
                                <p class="text-sm text-gray-600">{{ $t('worksite.files.file_modal.file_name') }}</p>
                                <p class="text-gray-900">{{ slotProps.model.name }}</p>
                            </div>
                            <div class="mb-4">
                                <p class="text-sm text-gray-600">{{ $t('worksite.files.file_modal.file_creation_date') }}</p>
                                <p class="text-gray-900">
                                    {{ $t('misc.datetime', {
                                        date: slotProps.model.created_at.format('DD MMMM YYYY'),
                                        time: slotProps.model.created_at.format('HH[h]mm')
                                    }) }}
                                </p>
                            </div>
                            <div class="mb-4">
                                <p class="text-sm text-gray-600">{{ $t('worksite.files.file_modal.file_size') }}</p>
                                <p class="text-gray-900">{{ slotProps.model.getReadableSize() }}</p>
                            </div>
                            <div class="mb-8">
                                <p class="text-sm text-gray-600">{{ $t('worksite.files.file_modal.file_added_by') }}</p>
                                <p class="text-gray-900" v-if="$store.getters.getUserName(slotProps.model.user_id)">{{ $store.getters.getUserName(slotProps.model.user_id) }}</p>
                                <p class="text-gray-900" v-else>{{ $t('worksite.files.file_modal.file_added_by_not_found') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between w-full">
                        <a
                            v-if="slotProps.model.currentCollection && slotProps.model.currentCollection.isNotEmpty()"
                            @click.prevent="openPreviousFile"
                            href="#"
                            class="flex items-center text-sm"
                            :class="{'text-gray-600 hover:text-gray-800': hasPreviousFile, 'text-gray-400 cursor-default': ! hasPreviousFile}"
                        >
                            <i class="mr-2 far fa-long-arrow-left" />
                            {{ $t('worksite.files.file_modal.previous_file') }}
                        </a>
    
                        <a href="#" class="text-sm text-gray-600 hover:text-red-600" @click.prevent="deleteFile(slotProps.model)">
                            {{ $t('worksite.files.file_modal.delete') }}
                        </a>
    
                        <a
                            v-if="slotProps.model.currentCollection && slotProps.model.currentCollection.isNotEmpty()"
                            @click.prevent="openNextFile"
                            href="#"
                            class="flex items-center text-sm"
                            :class="{'text-gray-600 hover:text-gray-800': hasNextFile, 'text-gray-400 cursor-default': ! hasNextFile}"
                        >
                            {{ $t('worksite.files.file_modal.next_file') }}
                            <i class="ml-2 far fa-long-arrow-right" />
                        </a>
                    </div>
                </div>
            </template>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksiteFile from '@spa/apps/trustup-pro-worksite-js/models/WorksiteFile';

    export default {
        components: {
            ModelModal
        },

        data() {
            return {
                modelClass: WorksiteFile,
                tab: 'preview'
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },
            currentFileIndex()
            {
                return this.model.currentCollection.findIndex(item => item.uuid == this.model.uuid);
            },
            hasPreviousFile()
            {
                return this.currentFileIndex > 0;
            },
            hasNextFile()
            {
                return this.currentFileIndex < (this.model.currentCollection.length() - 1);
            }
        },

        methods: {

            onOpening()
            {
                document.addEventListener('keyup', this.handleArrowKeyNavigation);
            },

            onReset()
            {
                this.tab = 'preview';
                document.removeEventListener('keyup', this.handleArrowKeyNavigation);
            },

            openPreviousFile()
            {
                if ( ! this.hasPreviousFile ) {
                    return;
                }

                this.$refs.modal.model = this.model.currentCollection.get()[this.currentFileIndex - 1];
            },

            openNextFile()
            {
                if ( ! this.hasNextFile ) {
                    return;
                }

                this.$refs.modal.model = this.model.currentCollection.get()[this.currentFileIndex + 1];
            },

            handleArrowKeyNavigation()
            {
                if ( event.key == 'ArrowLeft' ) {
                    this.openPreviousFile();
                }
                if ( event.key == 'ArrowRight' ) {
                    this.openNextFile();
                }
            },

            downloadFile(file)
            {
                file.download();
            },

            async deleteFile(file)
            {
                await file.getEndpoint().delete(file.uuid);

                this.$refs.modal.close();
            }
        }
    }
</script>